module.exports = __webpack_public_path__ + "static/media/lp6.609c7a0f.jpg";